import React from 'react';
import { Alert } from "react-bootstrap";
import { ExclamationCircle, ExclamationTriangleFill } from 'react-bootstrap-icons';

class AlertComponent extends React.Component {
    render() {
        return (
          <Alert variant={this.props.variant ? this.props.variant : "danger"}>
            {this.props.icon !== false && 
            
            this.props.variant === "warning"
            ?
              <ExclamationTriangleFill size={16} className="mb-1 mr-2 text-warning" />
            :
              <ExclamationCircle size={16} className="mb-1 mr-2 text-danger" />}

            {typeof this.props.label === "object"
            ?
            <>{this.props.label}</>
            :
            <span dangerouslySetInnerHTML={{ __html: this.props.label }} />
            }

            {this.props.body &&
              <div>{this.props.body}</div>
            }

          </Alert>
        );
    }
}

export default AlertComponent;